
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"13","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.505 6.864h4.5V7.99H8.13V6.864h4.5V7.99h1.125V6.64c0-.496-.404-.9-.9-.9H8.13v-1.5h.937a.75.75 0 00.75-.75V1.24a.75.75 0 00-.75-.75h-3a.75.75 0 00-.75.75v2.25a.748.748 0 00.75.75h.938v1.5H2.28c-.497 0-.9.404-.9.9v1.35h1.125V6.864zm3.937-3.75v-1.5h2.25v1.5h-2.25zm7.875 5.625h-2.25a.75.75 0 00-.75.75v2.25c0 .414.336.75.75.75h2.25a.75.75 0 00.75-.75V9.49a.75.75 0 00-.75-.75zm-.375 2.625h-1.5v-1.5h1.5v1.5zM8.692 8.74h-2.25a.75.75 0 00-.75.75v2.25c0 .414.336.75.75.75h2.25a.75.75 0 00.75-.75V9.49a.75.75 0 00-.75-.75zm-.375 2.625h-1.5v-1.5h1.5v1.5zM3.067 8.74H.817a.75.75 0 00-.75.75v2.25c0 .414.336.75.75.75h2.25a.75.75 0 00.75-.75V9.49a.75.75 0 00-.75-.75zm-.375 2.625h-1.5v-1.5h1.5v1.5z","fill":"#8A94A6"}})])
          )
        }
      }
    